//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { INgRedux } from 'ng-redux';

import { ICuralateStore } from '@models/AppState';
import { contentDrawerActions } from '@redux/content-drawer/contentDrawerActions';
import { IContentDrawerSettings } from '@redux/content-drawer/contentDrawerModel';
import curalateModule from 'app/curalate.module';

/**
 * This class provides access to the redux-based contentDrawerActions
 * for backwards compatibility with AngularJS components not hooked into redux.
 */
export class ContentDrawerSettingsService {
  private static mapStateToProps(state: ICuralateStore) {
    return {
      drawerSettings: state.contentDrawer.drawerSettings,
    };
  }

  public drawerSettings: IContentDrawerSettings;

  private unsubscribe: () => void;

  constructor(
    private $ngRedux: INgRedux,
  ) {
    this.unsubscribe = this.$ngRedux.connect(
      ContentDrawerSettingsService.mapStateToProps,
      contentDrawerActions,
    )(this);
  }

  public $onDestroy() {
    this.unsubscribe();
  }

  /**
   * This getter is only used by AngularJS components, so we'll declare
   * it here directly rather than mixing it into the rest of the actions.
   */
  public getPageSettings(): IContentDrawerSettings {
    return this.drawerSettings ?? {};
  }
}

export type IContentDrawerSettingsService = typeof ContentDrawerSettingsService & typeof contentDrawerActions;

curalateModule.service('ContentDrawerSettingsService', [
  '$ngRedux',
  ContentDrawerSettingsService,
]);
